<template>
  <div
    class="gov-utility-bar gov-ui-text bg-[#004d26] text-white"
    :class="[barClass, fixed ? 'fixed top-0 left-0 right-0 z-50 shadow-sm' : '']"
  >
    <div
      class="mx-auto flex flex-col gap-2 px-3 py-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-x-4 sm:gap-y-2 sm:px-4"
      :class="containerClass"
    >
      <div class="flex flex-wrap items-center gap-x-2 gap-y-1 opacity-95 sm:gap-x-4">
        <span>Government of Mizoram</span>
        <span class="text-white/70">|</span>
        <span>Department of School Education</span>
      </div>
      <div
        class="flex flex-wrap items-center gap-x-3 gap-y-1.5 sm:justify-end sm:gap-x-4 sm:gap-y-2"
      >
        <span class="opacity-90">
          Helpdesk
        </span>
        <span class="text-white/50 hidden sm:inline">|</span>
        <span class="opacity-90 hidden sm:inline">
          Transfer policy
        </span>
        <span class="text-white/50 hidden sm:inline">|</span>
        <a
          href="#"
          class="hover:underline opacity-90 hover:opacity-100"
          @click.prevent="onUtilityClick('contact')"
        >
          Contact
        </a>
        <span class="hidden sm:inline h-4 w-px bg-white/35 shrink-0" aria-hidden="true" />
        <div class="flex items-center shrink-0 pl-0 sm:pl-1" title="Display mode">
          <DarkModeToggle tone="lightOnDark" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DarkModeToggle from './DarkModeToggle.vue'

export type GovUtilityAction = 'helpdesk' | 'transfer-policy' | 'contact'

withDefaults(
  defineProps<{
    /** Tailwind max-width on inner row (matches login page). */
    containerClass?: string
    /** Extra classes on the outer bar. */
    barClass?: string
    /** Pin bar to top of viewport (authenticated shell). */
    fixed?: boolean
  }>(),
  {
    containerClass: 'max-w-6xl',
    barClass: '',
    fixed: false,
  },
)

const emit = defineEmits<{
  'utility-action': [action: GovUtilityAction]
}>()

function onUtilityClick(action: GovUtilityAction) {
  emit('utility-action', action)
}
</script>

